import React from "react"

import FTPServer from "../../../../components/Products/Outdoor_Cameras/IN-9008/Videos/video-9008-mount"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import Footer from '../../../../components/Layout/footer/'

const seodata = {
  title: 'INSTAR IN-9008 Full HD',
  description: 'The IN-9008 HD is the first INSTAR Outdoor IP Surveillance camera, utilizing our new Panasonic 1080p / fullHD image sensor.',
  image: '/images/Search/P_SearchThumb_IN-9008HD.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      IN-9008FullHD Montage
    </h1>
    <FTPServer />
    <br />
    <br />
    <Footer
      previousTitle="Usermanual"
      previousLink="/fr/Outdoor_Cameras/IN-9008_HD/Usermanual/"
      nextTitle="SD Card"
      nextLink="/fr/Outdoor_Cameras/IN-9008_HD/Video/SD_Card/" />
  </React.Fragment>
)